import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">精彩封面</h2>
          <p className="mt-2 text-sm text-foreground-500">热门韩漫封面精选，一眼爱上这些作品</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden mb-3" style={{ aspectRatio: '3/4' }}>
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-3">
                  <span className="text-xs text-white font-medium px-2 py-0.5 rounded-full bg-white/20">
                    {item.tag}
                  </span>
                </div>
                <span className={`absolute top-2 right-2 text-xs font-medium px-2 py-0.5 rounded-full ${
                  item.tag === '完结' ? 'bg-primary-500 text-background-50' : 'bg-accent-500 text-background-50'
                }`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 mb-1">{item.title}</h3>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-eye-line text-xs"></i>
                <span>{item.views}次浏览</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}